const ROLES_FOR_APP = {
  DASHBOARD_VIEW: "view",

  USER_MANAGEMENT: "user_management",
  COMPANY_MANAGEMENT: "company_management",

  ROLE_LIST: "role_list",
  ROLE_CREATE: "role_create",
  ROLE_UPDATE: "role_update",
  ROLE_DELETE: "role_remove",

  USER_LIST: "user_list",
  USER_CREATE: "user_create",
  USER_UPDATE: "user_update",
  USER_DELETE: "user_remove",

  PLAN_MANAGEMENT: "plan_management",
  PLAN_MANAGEMENT_CREATE: "plan_management_create",

  CONTENT_MANAGEMENT: "plan_management",
  CONTENT_MANAGEMENT_CREATE: "plan_management_create",

  USER_PLAN_PURCHASE_LIST: "user-plan-purchase",

  OPERATOR_LIST: "operator_management:operator:view",
  OPERATOR_CREATE: "operator_management:operator:view",
  OPERATOR_UPDATE: "operator_management:operator:view",
  OPERATOR_DELETE: "operator_management:operator:view",

  ACTIVITY_LOG_LIST: "operator_management:activity_log:view",

  SSO_LIST: "sso_list",
  SSO_MESSAGEHUB: "sso_messagehub",

  CONFIGURATION_LIST: "campaign_list",
  CONFIGURATION_CREATE: "campaign_create",
  CONFIGURATION_UPDATE: "campaign_update",
  CONFIGURATION_DELETE: "campaign_remove",
  APPLICATION_MANAGEMENT: "application_management",
  NOTICE_MANAGEMENT: "notice-management",
  JOB_POST_MANAGEMENT: "job_post_management",
  TALENT_MANAGEMENT: "talent_management",

  AGENCY_LIST_MANAGEMENT: "agency_management",

  POPUP_LIST_MANAGEMENT: "agency_management",

  COMMENT_MANAGEMENT: "comment_management"
};

const isHavePermissionRole = (
  keyRoles: string | string[],
  permissions: { id: string | number; name: string }[] = []
): boolean => {
  return true;
  const roles = typeof keyRoles === "string" ? [keyRoles] : keyRoles;
  return permissions?.some((item) => roles?.includes(item.name));
};

export { ROLES_FOR_APP, isHavePermissionRole };
